import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatCard, MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { AuthService } from 'src/app/services/auth.service';
import { Firestore, collection, query, where, getDocs, updateDoc, doc, setDoc } from '@angular/fire/firestore';

import * as bcrypt from 'bcryptjs';
import { Router } from '@angular/router';
import { last } from 'rxjs';

@Component({
  selector: 'app-virtualauthenticator',

  templateUrl: './virtualauthenticator.component.html',
  styleUrls: ['./virtualauthenticator.component.css'],
  animations: [
      trigger('slideInOut', [
        transition(':enter', [
          style({ transform: 'translateX(100%)', opacity: 0 }),
          animate('300ms ease-in', style({ transform: 'translateX(0)', opacity: 1 }))
        ]),
        transition(':leave', [
          animate('300ms ease-out', style({ transform: 'translateX(-100%)', opacity: 0 }))
        ])
      ])
    ]
})
export class VirtualauthenticatorComponent implements OnInit {

  phoneNumber: string = '';
  password: string = '';
  auth = new FirebaseTSAuth();
  zangiNumber: string = '';
  firstName: string = '';
  lastName: string = '';
 

  state = AuthenticatorCompState.LOGIN;
    firebasetsAuth: FirebaseTSAuth;
    constructor(private firestore: Firestore,private bottomSheetRef: MatBottomSheetRef, private authService: AuthService, private router: Router) { 
      this.firebasetsAuth = new FirebaseTSAuth();
    }
  
     isPlaying: boolean = true;
    
    
      @ViewChild('audioPlayer', { static: false }) audioPlayer!: ElementRef;
  
    ngOnInit(): void {
      this.changeAudioSrc(); // Joue l'audio au chargement
    }
  
    toggleAudio() {
      const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
      if (audio.paused) {
        audio.play();
        this.isPlaying = true;
      } else {
        audio.pause();
        this.isPlaying = false;
      }
    }
  
    onAudioPlay() {
      this.isPlaying = true;  // Mettre à jour l'état lorsque l'audio commence à jouer
    }
  
    onAudioPause() {
      this.isPlaying = false;  // Mettre à jour l'état lorsque l'audio est mis en pause
    }
  
    changeAudioSrc() {
      if (!this.audioPlayer) return;
  
      const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
      
      switch (this.state) {
        case AuthenticatorCompState.LOGIN:
          audio.src = "../../../assets/audio/02_Bambara_Connecter_Creer_Oublie.m4a";
          break;
        case AuthenticatorCompState.REGISTER:
          audio.src = "../../../assets/audio/03_Bambara_Creer_compte.m4a";
          break;
        case AuthenticatorCompState.FORGOT_PASSWORD:
          audio.src = "../../../assets/audio/audio_mot_de_passe_oublie.m4a";
          break;
        
      }
  
      audio.load(); // Recharge l'audio
      audio.play(); // Joue automatiquement après le changement
      this.isPlaying = true;
    }

    
  
    async login(loginEmail: HTMLInputElement,
      loginPassword: HTMLInputElement) {
        this.phoneNumber = loginEmail.value;
        this.password = loginPassword.value;
      if (!this.phoneNumber || !this.password) {
        console.log('Veuillez entrer votre numéro et votre mot de passe.');
        return;
      }
  
      try {
        // Rechercher l'utilisateur par son numéro de téléphone dans Firestore
        const usersRef = collection(this.firestore, 'Users');
        const q = query(usersRef, where('zangiNumber', '==', this.phoneNumber));
        const querySnapshot = await getDocs(q);
  
        if (querySnapshot.empty) {
          console.log('Numéro de téléphone introuvable.');
          return;
        }
  
        const userData = querySnapshot.docs[0].data();
        const uid = querySnapshot.docs[0].id;
        const storedPasswordHash = userData.password;
  
        // Vérifier le mot de passe (comparer avec le hash)
        if (!bcrypt.compareSync(this.password, storedPasswordHash)) {
          alert('Mot de passe incorrect.');
          return;
        }
  
        // Connexion avec Firebase Authentication (en recréant le compte)
        this.authService.signInWithEmailAndPassword(uid, this.password, this.phoneNumber)
          .then(() => {
            this.router.navigate(['/postfeed']);
          })
          .catch((error) => {
            console.error('Erreur lors de la connexion :', error);
            
          });
  
      } catch (error) {
        console.error('Erreur lors de la récupération des données utilisateur:', error);
        
      }
    }
  
  
  
   
     // Génère un numéro Zangi unique à 10 chiffres commençant par 10
  private generateZangiNumber(): string {
    // Génère 8 chiffres aléatoires pour compléter après le '10'
    const min = 10000000; // Minimum 8 chiffres
    const max = 99999999; // Maximum 8 chiffres
    const randomNumber = Math.floor(min + Math.random() * (max - min));
    
    // Formate le numéro pour avoir exactement 8 chiffres avec des zéros devant si nécessaire
    const paddedNumber = randomNumber.toString().padStart(8, '0');
    
    // Combine '10' avec les 8 chiffres aléatoires
    return '10' + paddedNumber;
  }
  
    onRegisterClick(
      registerFirstname: HTMLInputElement,
      registerLastname: HTMLInputElement,
    ){
      let firstname = registerFirstname.value;
      let name = registerLastname.value;
      
  
      if(
        this.isNotEmpty(firstname) &&
        this.isNotEmpty(name)
      ){

        const zangiNumber = this.generateZangiNumber();
        const userData = {
          firstname: firstname,
          lastname: name,
          zangiNumber: zangiNumber,
          password: '',  // Stockera un hash plus tard pour plus de sécurité
          createdAt: new Date().toISOString()
        };

        this.authService.loginAnonymously(firstname, name, zangiNumber);

        //alert(this.authService.loginAnonymously(firstname, name));
        

        if(userData.firstname && userData.lastname && userData.zangiNumber){
          this.state = AuthenticatorCompState.REGISTER2; // Passe à l'étape 2
          // Les informations enregistrés sont le nom et le prénom
          // L'utilisateur doit maintenant définir son mot de passe
          //alert("Votre Zangi ID est: " + zangiNumber);
        }
        
        this.zangiNumber = zangiNumber;
        this.firstName = firstname;
        this.lastName = name;

        
        

        

        
      }
  
    }

    onRegisterClick2(
      registerPassword: HTMLInputElement,
      registerConfirmPassword: HTMLInputElement
    ){
      let password = registerPassword.value;
      let confirmPassword = registerConfirmPassword.value;
  
      if(
        this.isNotEmpty(password) && 
        this.isNotEmpty(confirmPassword) &&
        this.isAMatch(password, confirmPassword)
      ){

       
        //Le numéro zangi doit être affiché dans la deuxième étape
        //l'utilisateur doit pouvoir definir son mot de passe

        this.saveProfile(this.firstName, this.lastName, password);
       
      }
  
    }


    async saveProfile(firstName: any, lastName: any, password: string) {
        const user = this.authService.auth.getAuth().currentUser;
        //alert(this.authService.auth.getAuth().currentUser.uid) ;
        if (user) {
          const hashedPassword = bcrypt.hashSync(password, 10); // 🔐 Hachage sécurisé
          try {
            //alert("Mise à jour du profil...");

            // Enregistrer dans Firestore
          await setDoc(doc(this.firestore, "Users", user.uid), {
            publicName: firstName + " " + lastName,
            coverPhotoUrl: "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c",
            description: "Bienvenue sur mon profil !",
            profilePhotoUrl: "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c",
            ville: "",
            followers: [],
            following: [],
            firstName: firstName,
            lastName: lastName,
            zangiNumber: this.zangiNumber,
            password: hashedPassword // 🔴 Stocker un hash sécurisé au lieu du mot de passe brut (bcrypt recommandé)
          })
          .then(() => {
            this.bottomSheetRef.dismiss();
            console.log("Utilisateur enregistré avec Zangi ID:", this.zangiNumber);
            this.router.navigate(['/postfeed']);
            //this.router.navigate(['/profileSetup']); // Rediriger vers la configuration du profil
          })
          .catch(error => console.error("Erreur Firestore:", error));


          
          } catch (error) {
            console.error("Erreur mise à jour profil:", error);
          }
        }
      }
  
    isNotEmpty(text: string){
      return text != null && text.length > 0;
    }
  
    isAMatch(text: string, comparedWith: string){
      return text == comparedWith;
    }
  
  
    onCreateAccountClick(){
      this.state = AuthenticatorCompState.REGISTER;
      this.changeAudioSrc();
    }
  
    onLoginClick(){
      this.state = AuthenticatorCompState.LOGIN;
      this.changeAudioSrc();
    }
  
    isLoginState(){
      return this.state == AuthenticatorCompState.LOGIN;
    }
  
    isRegisterState(){
      return this.state == AuthenticatorCompState.REGISTER;
    }

    isRegisterState2(){
      return this.state == AuthenticatorCompState.REGISTER2;
    }
  
    
  
    getStateText(){
      switch(this.state){
        case AuthenticatorCompState.LOGIN:
          return "Se connecter";
        case AuthenticatorCompState.REGISTER:
          return "S'inscrire";
        
      }
    }

    formatZangiNumber(): string {
      if (!this.zangiNumber) return '';
      
      // Diviser le numéro en groupes : 2 chiffres + 4 chiffres + 4 chiffres
      const firstPart = this.zangiNumber.substring(0, 2);
      const middlePart = this.zangiNumber.substring(2, 6);
      const lastPart = this.zangiNumber.substring(6, 10);
      
      // Retourner le numéro formaté avec des espaces
      return `${firstPart} ${middlePart} ${lastPart}`;
    }
}

export enum AuthenticatorCompState {
  LOGIN,
  REGISTER,
  FORGOT_PASSWORD,
  REGISTER2
}
